import { AfterViewInit, Component, inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './core/components/header/header.component';
import { SpinnerComponent } from './core/spinner/spinner.component';
import { HeaderService } from './core/services/header.service';
import { ToastService } from './core/services/toast.service';
import { ViewportVisivelService } from './core/services/viewport-visivel.service';
import { ToastComponent } from './shared/components/toast/toast.component';
import '@iframe-resizer/child';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SpinnerComponent, ToastComponent, HeaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements AfterViewInit {
  protected readonly headerService = inject(HeaderService);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly viewportVisivelService = inject(ViewportVisivelService);

  @ViewChild(ToastComponent) toastComponent!: ToastComponent;
  @ViewChild(SpinnerComponent) spinnerComponent?: SpinnerComponent;

  constructor(private readonly toastService: ToastService) {
    if (isPlatformBrowser(this.platformId)) {
      history.scrollRestoration = 'manual';
      this.viewportVisivelService.iniciar();
    }
  }

  ngAfterViewInit(): void {
    this.toastService.setToastComponent(this.toastComponent);
  }
}
